import { QuestionType } from '@/types/questionnaire'
import { ref } from '@vue/composition-api'
import {
  CreateChoiceDto,
  CreateCrossDto,
  QuestionEntity,
  UpdateChoiceDto,
  UpdateCrossDto,
} from '../../../api/@types'

export type QuestionForm = {
  type: QuestionType
  questionText: string
  annotationText: string
  answerSuffix: string | null
  minLength: number | null
  maxLength: number | null
  isRequiredAnswer: boolean
  isRandom: boolean
  htmlContent: string
  choices: (UpdateChoiceDto | CreateChoiceDto)[]
  crosses: (UpdateCrossDto | CreateCrossDto)[]
  enableLastChoice: boolean
}

export const useQuestionForm = (question: QuestionEntity | null) => {
  const input = ref<QuestionForm>({
    type: (question?.type as QuestionType) ?? QuestionType.TEXT,
    questionText: question?.questionText ?? '',
    annotationText: question?.annotationText ?? '',
    answerSuffix: question?.answerSuffix ?? null,
    minLength: question?.minLength ?? null,
    maxLength: question?.maxLength ?? null,
    isRequiredAnswer: question?.isRequiredAnswer ?? true,
    isRandom: question?.isRandom ?? false,
    htmlContent: question?.htmlContent ?? '',
    choices: question?.choices ?? [],
    crosses: question?.crosses ?? [],
    enableLastChoice: question?.choices.some(choice => choice.isLast) ?? false,
  })

  return { input }
}
